import { render, staticRenderFns } from "./RegistrationWelcomeCard.vue?vue&type=template&id=0a6626cb&"
import script from "./RegistrationWelcomeCard.vue?vue&type=script&lang=ts&"
export * from "./RegistrationWelcomeCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports